<template>
    <v-container fluid class="my-form-container" >
    <v-layout>
        <v-flex       md1 lg2 xl3 hidden-sm-and-down>

            <div class="">
                <v-card-text><!-- links --></v-card-text>
            </div>
        </v-flex>
        <v-flex xs12 sm12 md11 lg8 xl6>
            <slot name="slide-form">
            </slot>
        </v-flex>
        <v-flex           lg2 xl3 hidden-md-and-down>
            <div>
                <v-card-text><!-- rechts --></v-card-text>
            </div>
        </v-flex>
    </v-layout>
    </v-container>
</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>
  export default {
    name: 'StepTemplate',
    data: function () {
      return {}
    }, //===============================================================================================

  }
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style>
    div.container.my-form-container  {
        padding: 10px;
    }
</style>

